import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Transition } from 'react-transition-group';
import classNames from 'classnames';
import orderBy from 'lodash/orderBy';
import TimeAgo from 'react-timeago';
import { setState } from 'containers/Home/actions';

import { _firestore } from '../../firebase';
import './desktopBooking.css';
import Ratings from '../../components/Ratings';
import starGray from '../../assets/images/star-gray.svg';
import starYellow from '../../assets/images/star-yellow.svg';
import { selectStoreConfig } from '../../containers/Layout/selectors';
import { selectIsEnabledGoogleReview } from '../../containers/Home/selectors';
import Map from 'components/Map';

class AboutDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDeliveryAreas: false,
      displayStoreTimings: false,
      displayReviewScreen: false,
      showScroll: true,
      allLoaded: false,
      mapLoaded: false,
    };
  }

  componentDidMount() {
    const { storeConfig } = this.props;
    this.setState({ showLoader: true });

    let nextRef = _firestore
      .collection('Reviews')
      .where('storeId', '==', storeConfig.storeId)
      .where('isVisible', '==', true)
      .orderBy('dateTimestamp', 'desc')
      .limit(25);

    nextRef.get().then((querySnapshot) => {
      var dataArray = [];
      querySnapshot.forEach((doc) => {
        dataArray.push({ _id: doc.id, ...doc.data() });
      });

      this.setState({
        allReviews: dataArray,
        isLoading: false,
        showLoader: false,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.userDetails &&
      this.props.userDetails &&
      this.props.userDetails.mobileNumber &&
      this.state.allowNewBooking
    ) {
      this.setState({ showConfirmationScreen: true });
    }
  }

  loadReviews = (totalReviews) => {
    const { storeConfig } = this.props;
    this.setState({ showLoader: true });

    let limit =
      this.state.allReviews.length + 10 < totalReviews
        ? this.state.allReviews.length + 10
        : totalReviews;

    let nextRef = _firestore
      .collection('Reviews')
      .where('storeId', '==', storeConfig.storeId)
      .orderBy('dateTimestamp', 'desc')
      .limit(limit);

    nextRef.get().then((querySnapshot) => {
      var dataArray = [];
      querySnapshot.forEach((doc) => {
        dataArray.push({ _id: doc.id, ...doc.data() });
      });

      this.setState(
        {
          allReviews: dataArray,
          showLoader: false,
        },
        () => {
          if (dataArray.length === totalReviews) {
            this.setState({
              allLoaded: true,
            });
          }
        }
      );
    });
  };

  getReviewPercentage = (rating) => {
    if (
      this.props.reviewStatsByRating &&
      this.props.reviewStatsByRating.length > 0 &&
      this.props.reviewStats
    ) {
      let rList = this.props.reviewStatsByRating.filter((f) => {
        return Number(f.rating) === rating;
      });
      if (rList.length > 0)
        return (
          (rList[0].totalReviews * 100) / this.props.reviewStats.totalReviews
        );
      else return 0;
    }
    return 0;
  };

  handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

    if (
      this.props.reviewStats &&
      this.props.reviewStats.totalReviews &&
      this.state.allReviews.length < this.props.reviewStats.totalReviews
    ) {
      if (bottom) {
        this.loadReviews(this.props.reviewStats.totalReviews);
      }
    }
  };

  openDeliveryAreas = () => {
    this.setState({
      displayDeliveryAreas: true,
      showAnimation: false,
    });
  };

  openStoreTimings = () => {
    this.setState({
      displayStoreTimings: true,
      showAnimation: false,
    });
  };

  showAnimationBeforeClose = () => {
    this.setState(
      {
        showAnimation: true,
        showScroll: false,
      },
      () => {
        setTimeout(() => {
          this.setState({
            displayDeliveryAreas: false,
            displayStoreTimings: false,
            displayReviewScreen: false,
          });
        }, 300);
      }
    );
  };

  renderDeliveryAreasScreen = () => {
    const { storeConfig } = this.props;
    let deliveryAreasClass = classNames({
      'delivery-areas-container true about-slide-in-animation':
        this.state.displayDeliveryAreas,
      'delivery-areas-container': !this.state.displayDeliveryAreas,
      'about-slide-out-animation': this.state.showAnimation,
    });

    return (
      <div className={deliveryAreasClass}>
        <button
          className='card__cntrl'
          onClick={this.showAnimationBeforeClose}
        ></button>
        <div className='detailsTitle oH' style={{ marginTop: 0 }}>
          Delivery Areas
        </div>
        <ul style={{ overflow: 'auto', height: 'calc(100vh - 220px)' }}>
          {this.props?.allSuburbs?.map((item, index) => (
            <li key={index} style={{ paddingRight: '4px' }}>
              {item.name}
              <span>
                {storeConfig.currency} {item.deliveryCost}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  getOpeningHours = (day) => {
    let time = '';
    if (this.props.allShifts) {
      let todaysShifts = this.props.allShifts.filter((s) => {
        return Number(s.day) === day;
      });
      todaysShifts = todaysShifts.map((t) => {
        t.openingStart = Number(t.openingStart);
        return t;
      });
      todaysShifts = orderBy(todaysShifts, 'openingStart', 'asc');
      todaysShifts.map((a, i) => {
        i === 0
          ? (time =
              time +
              (a.openingStart === 0 ? '12:00 AM' : a.openingStartDisplay) +
              ' - ' +
              a.openingEndDisplay)
          : (time =
              time +
              ', ' +
              (a.openingStart === 0 ? '12:00 AM' : a.openingStartDisplay) +
              ' - ' +
              a.openingEndDisplay);
        return i;
      });
    }
    if (time === '') {
      time = 'Closed';
    }
    return time;
  };

  renderStoreTimingsScreen = () => {
    const { storeConfig } = this.props;
    let openHoursClass = classNames({
      'delivery-areas-container true about-slide-in-animation':
        this.state.displayStoreTimings,
      'delivery-areas-container': !this.state.displayStoreTimings,
      'about-slide-out-animation': this.state.showAnimation,
    });

    var day =
      moment().tz(storeConfig.timeZone).weekday() === 0
        ? 7
        : moment().tz(storeConfig.timeZone).weekday();
    return (
      <div className={openHoursClass}>
        <button
          className='card__cntrl'
          onClick={this.showAnimationBeforeClose}
        ></button>
        <div className='detailsTitle oH' style={{ marginTop: 0 }}>
          Opening Hours
        </div>
        <ul style={{ overflow: 'auto', height: 'calc(100vh - 208px)' }}>
          <li>
            {day === 1 ? <strong>Monday</strong> : 'Monday'}
            {day === 1 ? (
              <span>
                <strong>{this.getOpeningHours(1)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(1)}</span>
            )}
          </li>
          <li>
            {day === 2 ? <strong>Tuesday</strong> : 'Tuesday'}
            {day === 2 ? (
              <span>
                <strong>{this.getOpeningHours(2)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(2)}</span>
            )}
          </li>
          <li>
            {day === 3 ? <strong>Wednesday</strong> : 'Wednesday'}
            {day === 3 ? (
              <span>
                <strong>{this.getOpeningHours(3)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(3)}</span>
            )}
          </li>
          <li>
            {day === 4 ? <strong>Thursday</strong> : 'Thursday'}
            {day === 4 ? (
              <span>
                <strong>{this.getOpeningHours(4)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(4)}</span>
            )}
          </li>
          <li>
            {day === 5 ? <strong>Friday</strong> : 'Friday'}
            {day === 5 ? (
              <span>
                <strong>{this.getOpeningHours(5)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(5)}</span>
            )}
          </li>
          <li>
            {day === 6 ? <strong>Saturday</strong> : 'Saturday'}
            {day === 6 ? (
              <span>
                <strong>{this.getOpeningHours(6)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(6)}</span>
            )}
          </li>
          <li>
            {day === 7 ? <strong>Sunday</strong> : 'Sunday'}
            {day === 7 ? (
              <span>
                <strong>{this.getOpeningHours(7)}</strong>
              </span>
            ) : (
              <span>{this.getOpeningHours(7)}</span>
            )}
          </li>
        </ul>
      </div>
    );
  };

  renderDisplayReviewScreen = () => {
    let reviewsClass = classNames({
      'delivery-areas-container  true about-slide-in-animation':
        this.state.displayReviewScreen,
      'delivery-areas-container': !this.state.displayReviewScreen,
      'about-slide-out-animation': this.state.showAnimation,
    });

    return (
      <React.Fragment>
        <div className={reviewsClass}>
          <button
            className='card__cntrl'
            onClick={this.showAnimationBeforeClose}
          ></button>
          <div className='detailsTitle oH' style={{ marginTop: 0 }}>
            Reviews
          </div>
          <div className='uRstarC'>
            <div className='uRleftC'>
              <div>
                {this.props.reviewStats?.averageRating
                  ? Number(this.props.reviewStats.averageRating).toFixed(1)
                  : 'N/A'}
              </div>
              <div>out of 5</div>
            </div>
            <div className='uRrightC'>
              <div className='uRstarMain'>
                <div className='urRow'>
                  <div className='urLeftSec'>
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                  </div>
                  <div className='urRightSec'>
                    <div className='progressBar'>
                      <div
                        className='prgFill'
                        style={{ width: `${this.getReviewPercentage(5)}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className='urRow'>
                  <div className='urLeftSec'>
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                  </div>
                  <div className='urRightSec'>
                    <div className='progressBar'>
                      <div
                        className='prgFill'
                        style={{ width: `${this.getReviewPercentage(4)}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className='urRow'>
                  <div className='urLeftSec'>
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                  </div>
                  <div className='urRightSec'>
                    <div className='progressBar'>
                      <div
                        className='prgFill'
                        style={{ width: `${this.getReviewPercentage(3)}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className='urRow'>
                  <div className='urLeftSec'>
                    <img src={starYellow} alt='' />
                    <img src={starYellow} alt='' />
                  </div>
                  <div className='urRightSec'>
                    <div className='progressBar'>
                      <div
                        className='prgFill'
                        style={{ width: `${this.getReviewPercentage(2)}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className='urRow'>
                  <div className='urLeftSec'>
                    <img src={starYellow} alt='' />
                  </div>
                  <div className='urRightSec'>
                    <div className='progressBar'>
                      <div
                        className='prgFill'
                        style={{ width: `${this.getReviewPercentage(1)}%` }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='uRRev'>
                {`${
                  this.props.reviewStats && this.props.reviewStats.totalReviews
                    ? this.props.reviewStats.totalReviews
                    : 0
                }
                 Reviews`}
              </div>
            </div>
          </div>
          <div
            id='reviewListWrap'
            onScroll={this.handleScroll}
            className={
              this.state.showLoader
                ? 'reviewListWrap loading'
                : 'reviewListWrap'
            }
            style={{ overflowY: 'auto', height: 'calc(100vh - 300px)' }}
          >
            {this.state.allReviews &&
              !this.state.isLoading &&
              this.state.allReviews.map((r, i) => (
                <React.Fragment key={i}>
                  {r.isVisible === true && (
                    <div
                      key={i}
                      className={`${
                        this.state.allLoaded === true
                          ? `reviewListItem allReviewsLoaded`
                          : `reviewListItem`
                      }`}
                    >
                      <div className='rlTitleWrap'>
                        <div className='rlTitle'>
                          {r.firstName ? r.firstName : r.userName}
                        </div>
                        <div className='rlrating'>
                          {new Array(Number(r.rating)).fill().map((_, p) => (
                            <img key={p} src={starYellow} alt='' />
                          ))}
                          {new Array(5 - Number(r.rating))
                            .fill()
                            .map((_, p) => (
                              <img key={p} src={starGray} alt='' />
                            ))}
                        </div>
                      </div>
                      <div className='rlDate'>
                        <TimeAgo date={r.dateTimestamp} live={false} />
                      </div>
                      <div className='rlRating'>{r.comment && r.comment}</div>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
      </React.Fragment>
    );
  };

  openReviewScreen = () => {
    this.setState({
      displayReviewScreen: true,
      showAnimation: false,
    });
  };

  render() {
    const { storeConfig, isEnableGoogleReview, aboutOpen, setState } =
      this.props;

    const transitionStyles = {
      entering: { transform: `translateX(100%)` },
      entered: { transform: `translateX(0)` },
      exiting: { transform: `translateX(100%)` },
      exited: { transform: `translateX(100%)`, display: `none` },
    };

    return (
      <Transition in={aboutOpen} timeout={250}>
        {(state) => (
          <div
            id='about-desktop'
            style={{
              zIndex: 9,
              position: `absolute`,
              width: `100%`,
              top: `98px`,
              right: 0,
              transition: `transform .25s ease-out`,
              ...transitionStyles[state],
            }}
          >
            <div>
              {this.state.displayDeliveryAreas === true &&
                this.renderDeliveryAreasScreen()}
              {this.state.displayStoreTimings === true &&
                this.renderStoreTimingsScreen()}
              {this.state.displayReviewScreen === true &&
                this.renderDisplayReviewScreen()}
              <aside className='sidebar'>
                <div className='sidebar__wrapper'>
                  <div className='card__about'>
                    <div className='card__header'>
                      <button
                        className='card__cntrl'
                        onClick={() => setState({ aboutOpen: false })}
                      ></button>
                      <div className='card__name'>{storeConfig.name}</div>
                      <div className='card__category'>{storeConfig.type}</div>
                      <div className='card__rating'>
                        {/*Reviews Section */}
                        {this.props.reviewStats?.averageRating && (
                          <Ratings
                            rating={
                              this.props.reviewStats.averageRating
                                ? Number(
                                    this.props.reviewStats.averageRating
                                  ).toFixed(1)
                                : 0
                            }
                          />
                        )}
                      </div>
                    </div>

                    {aboutOpen && storeConfig?.addressLocation && (
                      <div className='card__map'>
                        <Map
                          lat={storeConfig.addressLocation.lat}
                          long={storeConfig.addressLocation.long}
                        />
                      </div>
                    )}

                    <ul className='card__info'>
                      <li className='card__info-item'>
                        <div>{storeConfig.address}</div>
                      </li>
                      {storeConfig.phoneNumberDisplay ||
                      storeConfig.emailAddress ? (
                        <li className='card__info-item'>
                          <div>
                            {storeConfig.phoneNumberDisplay ||
                              storeConfig.emailAddress}
                            <a
                              className='card__call'
                              href={
                                storeConfig.phoneNumberDisplay
                                  ? `tel:${storeConfig.phoneNumber}`
                                  : `mailto:${storeConfig.emailAddress}`
                              }
                              title='Contact restaurant'
                            >
                              {storeConfig.phoneNumberDisplay ? 'Call' : 'Mail'}
                            </a>
                          </div>
                        </li>
                      ) : null}

                      <li
                        className='card__info-item'
                        onClick={this.openStoreTimings}
                      >
                        <a className='card__link'>
                          <div>
                            {this.props.currentShift &&
                            this.props.currentShift.isPickupOpen
                              ? 'Open'
                              : 'Closed'}
                            <span className='card__time'></span>
                          </div>
                        </a>
                      </li>

                      {!isEnableGoogleReview ? (
                        <li
                          className='card__info-item'
                          onClick={this.openReviewScreen}
                        >
                          <a className='card__link'>
                            <div>
                              {this.props.reviewStats &&
                              this.props.reviewStats.totalReviews ? (
                                <React.Fragment>{`${this.props.reviewStats.totalReviews} `}</React.Fragment>
                              ) : null}
                              Reviews
                            </div>
                          </a>
                        </li>
                      ) : null}
                      {this.props.isDeliveryOn === true &&
                        this.props?.allSuburbs?.length > 0 && (
                          <li
                            className='card__info-item'
                            onClick={this.openDeliveryAreas}
                          >
                            <a className='card__link'>
                              <div>Delivery Areas</div>
                            </a>
                          </li>
                        )}
                      <li className='card__info-item'>
                        <a
                          className='card__link_terms'
                          rel='noopener noreferrer'
                          title='Opens in a new window'
                          target='_blank'
                          href='https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/Terms+and+Conditions+Next+Order.pdf'
                        >
                          <div>Terms &amp; Conditions</div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        )}
      </Transition>
    );
  }
}

AboutDesktop.propTypes = {
  isItemViewVisible: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    isEnableGoogleReview: selectIsEnabledGoogleReview(state),
    storeConfig: selectStoreConfig(state),
    aboutOpen: state.homeReducer.aboutOpen,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setState: (payload) => dispatch(setState(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutDesktop);
